import ElCheckbox from 'element-ui/packages/checkbox';
import ElTag from 'element-ui/packages/tag';
import objectAssign from 'element-ui/src/utils/merge';
// import { getPropByPath } from '../../../common/utils/util';
import { getValueByPath } from 'element-ui/src/utils/util';
import { DateFun,ArrayFun } from './util'

let columnIdSeed = 1;

const defaults = {
  default: {
    order: ''
  },
  selection: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: '',
    className: 'el-table-column--selection'
  },
  expand: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: ''
  },
  index: {
    width: 48,
    minWidth: 48,
    realWidth: 48,
    order: ''
  },
  edit:{
    width: 150,
    minWidth: 150,
    realWidth: 150,
    order: ''
  }
};

const forced = {
  selection: {
    renderHeader: function(h) {
      return <el-checkbox
        nativeOn-click={ this.toggleAllSelection }
        value={ this.isAllSelected } />;
    },
    renderCell: function(h, { row, column, store, $index }) {
      return <el-checkbox
        value={ store.isSelected(row) }
        disabled={ column.selectable ? !column.selectable.call(null, row, $index) : false }
        on-input={ () => { store.commit('rowSelectedChanged', row); } } />;
    },
    sortable: false,
    resizable: false
  },
  index: {
    renderHeader: function(h, { column }) {
      return column.label || '#';
    },
    renderCell: function(h, { $index, column }) {
      let i = $index + 1;
      const index = column.index;

      if (typeof index === 'number') {
        i = $index + index;
      } else if (typeof index === 'function') {
        i = index($index);
      }

      return <div>{ i }</div>;
    },
    sortable: false
  },
  expand: {
    renderHeader: function(h, {}) {
      return '';
    },
    renderCell: function(h, { row, store }, proxy) {
      const expanded = store.states.expandRows.indexOf(row) > -1;
      return <div class={ 'el-table__expand-icon ' + (expanded ? 'el-table__expand-icon--expanded' : '') }
                  on-click={ () => proxy.handleExpandClick(row) }>
        <i class='el-icon el-icon-arrow-right'></i>
      </div>;
    },
    sortable: false,
    resizable: false,
    className: 'el-table__expand-column'
  },
  //操作列
  edit:{
    renderHeader:function(h, { column }){
      return column.label || '操作';
    },
    renderCell:function(h, data,_self) {
      let successCallback=function(state){
        if(state===true){
          data.row.id=data.row.id?data.row.id:data.row.testId;
          data.row.isEdit=false;
          console.log('提交成功',data)
        }
      };
      let deleteCallback=function(state){
        if(state===true){
          data.row.isEdit=false;
          console.log('删除成功！')
        }
      };
      return data.row.isEdit?
      <div>
        {_self.successButton?
        <el-button size="small" type="success" icon="check" on-click={ (val) => { 
          data.row.isEdit=true;
          let row=JSON.parse(JSON.stringify(data.row));
          delete row.isEdit;delete row.testId;
          _self.$emit('success',row,successCallback)
          } } ></el-button>:''}
        {_self.cancelButton?<el-button size="small" type="danger" icon="close" on-click={ () => {
          let item=_self.historyData.find((element) => {return element.testId==data.row.testId});
          if(item){
              data.row=Object.assign(data.row,item);
              _self.historyData.remove(item);
          }
          if(data.row.id==0){
            data.store.table.data.remove(data.row);
          }
            data.row.isEdit=false;
        } } ></el-button>:''}
      </div>:
      <div>
        {_self.editButton?<el-button size="small" type="primary" icon="edit" on-click={ (val) => { 
            let item=_self.historyData.find((element) => {return element.testId==data.row.testId});
            if(!item){
              _self.historyData.remove(item);
              _self.historyData.push(JSON.parse(JSON.stringify(data.row)));
            }
            data.row.isEdit=true;
          } } ></el-button>:''}
        {_self.deleteButton?<el-button size="small" type="danger" icon="delete" on-click={ (val) => {  
          let row=JSON.parse(JSON.stringify(data.row));
          delete row.isEdit;delete row.testId;
            _self.$emit('delete',row,deleteCallback) 
          } } ></el-button>:''}
      </div>
      ;
    },
    sortable: false,
    resizable: false,
  }
};

const getDefaultColumn = function(type, options) {
  const column = {};

  objectAssign(column, defaults[type || 'default']);

  for (let name in options) {
    if (options.hasOwnProperty(name)) {
      const value = options[name];
      if (typeof value !== 'undefined') {
        column[name] = value;
      }
    }
  }

  if (!column.minWidth) {
    column.minWidth = 80;
  }

  column.realWidth = column.width || column.minWidth;

  return column;
};

// const DEFAULT_RENDER_CELL = function(h, { row, column }) {
//   const property = column.property;
//   const value = property && getPropByPath(row, property).v;
//   if (column && column.formatter) {
//     return column.formatter(row, column, value);
//   }
//   return value;
// };
const DEFAULT_RENDER_CELL = function(h, { row, column }) {
  const property = column.property;
  const value = property && property.indexOf('.') === -1
    ? row[property]
    : getValueByPath(row, property);
  if (column && column.formatter) {
    return column.formatter(row, column, value);
  }
  return value;
};

export default {
  name: 'ElTableColumnEdit',

  props: {
    type: {
      type: String,
      default: 'default'
    },
    label: String,
    className: String,
    labelClassName: String,
    property: String,
    prop: String,
    width: {},
    minWidth: {},
    renderHeader: Function,
    sortable: {
      type: [String, Boolean],
      default: false
    },
    sortMethod: Function,
    resizable: {
      type: Boolean,
      default: true
    },
    context: {},
    columnKey: String,
    align: String,
    headerAlign: String,
    showTooltipWhenOverflow: Boolean,
    showOverflowTooltip: Boolean,
    fixed: [Boolean, String],
    formatter: Function,
    selectable: Function,
    reserveSelection: Boolean,
    filterMethod: Function,
    filteredValue: Array,
    filters: Array,
    filterPlacement: String,
    filterMultiple: {
      type: Boolean,
      default: true
    },
    index: [Number, Function],
    propType:{
      type:String,
      default:function(){
          return 'input'
      }
    },//行单位的类型
    edit:Boolean,
    options:Array,
    editButton:{
      type:Boolean,
      default:true
    },
    deleteButton:{
      type:Boolean,
      default:true
    },
    successButton:{
      type:Boolean,
      default:true
    },
    cancelButton:{
      type:Boolean,
      default:true
    },
  },

  data() {
    return {
      isSubColumn: false,
      columns: [],
      historyData:[],
    };
  },

  beforeCreate() {
    this.row = {};
    this.column = {};
    this.$index = 0;
  },

  components: {
    ElCheckbox,
    ElTag,
  },

  computed: {
    owner() {
      let parent = this.$parent;
      while (parent && !parent.tableId) {
        parent = parent.$parent;
      }
      return parent;
    }
  },

  created() {
    this.customRender = this.$options.render;
    this.$options.render = h => h('div', this.$slots.default);
    this.columnId = (this.$parent.tableId || (this.$parent.columnId + '_')) + 'column_' + columnIdSeed++;

    let parent = this.$parent;
    let owner = this.owner;
    this.isSubColumn = owner !== parent;

    let type = this.type;
    let edit = this.edit;
    let propType=this.propType;

    let width = this.width;
    if (width !== undefined) {
      width = parseInt(width, 10);
      if (isNaN(width)) {
        width = null;
      }
    }

    let minWidth = this.minWidth;
    if (minWidth !== undefined) {
      minWidth = parseInt(minWidth, 10);
      if (isNaN(minWidth)) {
        minWidth = 80;
      }
    }

    let isColumnGroup = false;

    let column = getDefaultColumn(type, {
      id: this.columnId,
      columnKey: this.columnKey,
      label: this.label,
      className: this.className,
      labelClassName: this.labelClassName,
      property: this.prop || this.property,
      type,
      renderCell: null,
      renderHeader: this.renderHeader,
      minWidth,
      width,
      isColumnGroup,
      context: this.context,
      align: this.align ? 'is-' + this.align : null,
      headerAlign: this.headerAlign ? 'is-' + this.headerAlign : (this.align ? 'is-' + this.align : null),
      sortable: this.sortable === '' ? true : this.sortable,
      sortMethod: this.sortMethod,
      resizable: this.resizable,
      showOverflowTooltip: this.showOverflowTooltip || this.showTooltipWhenOverflow,
      formatter: this.formatter,
      selectable: this.selectable,
      reserveSelection: this.reserveSelection,
      fixed: this.fixed === '' ? true : this.fixed,
      filterMethod: this.filterMethod,
      filters: this.filters,
      filterable: this.filters || this.filterMethod,
      filterMultiple: this.filterMultiple,
      filterOpened: false,
      filteredValue: this.filteredValue || [],
      filterPlacement: this.filterPlacement || '',
      index: this.index,
      propType:this.propType,
      edit:this.edit,
      options:this.options,
    });

    objectAssign(column, forced[type] || {});

    this.columnConfig = column;

    let renderCell = column.renderCell;
    let _self = this;

    if (type === 'expand') {
      owner.renderExpanded = function(h, data) {
        return _self.$scopedSlots.default
          ? _self.$scopedSlots.default(data)
          : _self.$slots.default;
      };

      column.renderCell = function(h, data) {
        return <div class="cell">{ renderCell(h, data, this._renderProxy) }</div>;
      };

      return;
    }
    let editRenderCell=column.renderCell;
    //判断数据的类型进行渲染组件
    if(edit){
        switch(propType){
          case 'input':editRenderCell = function(h, { row, column, store, $index }) {
            return row.isEdit?<el-input value={ row[_self.prop] } onInput={val => { row[_self.prop]=val;row.isEdit=row.isEdit }} size='mini'></el-input>:<div class="cell"> { row[_self.prop] }  </div> }
           ;break;
          case 'inputNumber':editRenderCell = function(h, { row, column, store, $index }) {
            return row.isEdit?<el-input-number value={ row[_self.prop] } onInput={val => { row[_self.prop]=val }} size='mini' controls={false}></el-input-number>:<div class="cell"> { row[_self.prop] }  </div>}
          ;break;
          case 'select':editRenderCell = function(h, { row, column, store, $index }) {
            return row.isEdit?<el-select value={ row[_self.prop] } onInput={val => { row[_self.prop]=val }} size='mini' controls={false}>
            {
              column.options.map((item) => {
                return <el-option value={ item.value } label={ item.name }></el-option>
              })
            }
            </el-select>:<div class="cell"> { row[_self.prop] }  </div>}
          ;break;
          case 'switch':
          ;break;
          case 'datePicker':editRenderCell = function(h, { row, column, store, $index }) {
            return row.isEdit?<el-date-picker value={ row[_self.prop] } onInput={val => { row[_self.prop]=val?new Date(val).format('yyyy-MM-dd'):''; }} size='mini' type="date" style="width:100%"></el-date-picker>:<div class="cell"> { row[_self.prop] }  </div>}
          ;break;
          case 'dateTimePicker':editRenderCell = function(h, { row, column, store, $index }) {
            return row.isEdit?<el-date-picker value={ row[_self.prop] } onInput={val => { row[_self.prop]=val?new Date(val).format('yyyy-MM-dd hh:mm:ss'):''; }} size='mini' type="datetime" ></el-date-picker>:<div class="cell"> { row[_self.prop] }  </div>}
          ;break;
          case 'rate':;break;
          case 'colorPicker':;break;
          default:break;
        }      
    }
    let setItem=function(row,realKey,realVal,judge){
      if(judge){
        return realVal
      }else{
        return row[realKey];
      }
    }
    let resetRow=function(h, { row }){
      _self.$set(row,'isEdit',setItem(row,'isEdit',false,row['isEdit']==undefined))  
      _self.$set(row,'testId',setItem(row,'testId',Math.random(),!row['testId']))
      _self.$set(row,'id',setItem(row,'id',0,row['id']==undefined))  //参数：数据，字段名，期望值，判断条件
    }

    column.renderCell = function(h, data) {
      resetRow(h,data)
      if (_self.$scopedSlots.default) {
        renderCell = () => _self.$scopedSlots.default(data);
      }
      if(column.type=='edit'){
        return renderCell(h,data,_self)
      }

      if (!renderCell) {
        renderCell = DEFAULT_RENDER_CELL;
      }
      if(_self.edit){
        return <div class="cell">
        { editRenderCell(h, data) }
        </div>
      }else{
        return _self.showOverflowTooltip || _self.showTooltipWhenOverflow
        ? <div class="cell el-tooltip" style={'width:' + (data.column.realWidth || data.column.width) + 'px'}>{ renderCell(h, data) }</div>
        : <div class="cell">{ renderCell(h, data) }</div>;
      }
    };
  },

  destroyed() {
    if (!this.$parent) return;
    this.owner.store.commit('removeColumn', this.columnConfig);
  },

  watch: {
    label(newVal) {
      if (this.columnConfig) {
        this.columnConfig.label = newVal;
      }
    },

    prop(newVal) {
      if (this.columnConfig) {
        this.columnConfig.property = newVal;
      }
    },

    property(newVal) {
      if (this.columnConfig) {
        this.columnConfig.property = newVal;
      }
    },

    filters(newVal) {
      if (this.columnConfig) {
        this.columnConfig.filters = newVal;
      }
    },

    filterMultiple(newVal) {
      if (this.columnConfig) {
        this.columnConfig.filterMultiple = newVal;
      }
    },

    align(newVal) {
      if (this.columnConfig) {
        this.columnConfig.align = newVal ? 'is-' + newVal : null;

        if (!this.headerAlign) {
          this.columnConfig.headerAlign = newVal ? 'is-' + newVal : null;
        }
      }
    },

    headerAlign(newVal) {
      if (this.columnConfig) {
        this.columnConfig.headerAlign = 'is-' + (newVal ? newVal : this.align);
      }
    },

    width(newVal) {
      if (this.columnConfig) {
        this.columnConfig.width = newVal;
        this.owner.store.scheduleLayout();
      }
    },

    minWidth(newVal) {
      if (this.columnConfig) {
        this.columnConfig.minWidth = newVal;
        this.owner.store.scheduleLayout();
      }
    },

    fixed(newVal) {
      if (this.columnConfig) {
        this.columnConfig.fixed = newVal;
        this.owner.store.scheduleLayout();
      }
    },

    sortable(newVal) {
      if (this.columnConfig) {
        this.columnConfig.sortable = newVal;
      }
    },

    index(newVal) {
      if (this.columnConfig) {
        this.columnConfig.index = newVal;
      }
    }
  },

  mounted() {
    const owner = this.owner;
    const parent = this.$parent;
    let columnIndex;

    if (!this.isSubColumn) {
      columnIndex = [].indexOf.call(parent.$refs.hiddenColumns.children, this.$el);
    } else {
      columnIndex = [].indexOf.call(parent.$el.children, this.$el);
    }

    owner.store.commit('insertColumn', this.columnConfig, columnIndex, this.isSubColumn ? parent.columnConfig : null);
  }
};



// WEBPACK FOOTER //
// ./src/table-column.js